import { useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { ArrowRight, Search } from "lucide-react";
import { useContent } from "@/lib/api";
import { Hl } from "@/pages/Rules";
import { PageHero, Skeleton, Wrap } from "@/night/ui";
import NotFound from "@/night/NotFound";

export default function RuleDetail() {
  const { slug } = useParams();
  const [sp] = useSearchParams();
  const [q, setQ] = useState(sp.get("q") || "");
  const { data = [], isLoading } = useContent("rules");
  if (isLoading) return <Skeleton />;
  const r = data.find((x) => x.slug === slug);
  if (!r) return <NotFound />;
  const t = q.trim();
  const lt = t.toLowerCase();
  const sections = t ? r.sections.map((s) => ({ ...s, items: s.items.filter((i) => i.toLowerCase().includes(lt) || s.title.toLowerCase().includes(lt)) })).filter((s) => s.items.length) : r.sections;
  return (
    <>
      <PageHero en={r.tag} ar={r.name} desc={r.summary}>
        <div className="mt-10 flex flex-wrap items-center gap-3">
          <Link to="/rules" className="btn-ghost" data-testid="rule-back-btn"><ArrowRight size={16} />كل القوانين</Link>
          <div className="relative w-full max-w-sm">
            <Search size={16} className="absolute right-4 top-1/2 -translate-y-1/2 text-[var(--n-cyan)]" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="ابحث في هذا القسم" className="field !pr-11" data-testid="rule-search-input" />
          </div>
        </div>
      </PageHero>
      <Wrap className="mt-16 grid gap-12 lg:grid-cols-[280px_1fr]">
        <aside className="hidden lg:block">
          <nav className="sticky top-28 border-r-2 border-[var(--n-line)]">
            {sections.map((s, i) => <a key={i} href={`#s${i}`} className="-mr-0.5 block border-r-2 border-transparent py-2 pr-5 text-sm text-slate-400 transition-colors hover:border-[var(--n-cyan)] hover:text-white">{s.title}</a>)}
          </nav>
        </aside>
        <div data-testid="rule-sections">
          {!sections.length && <p className="border border-[var(--n-line)] p-10 text-center text-slate-400">ما فيه نتائج</p>}
          {sections.map((s, i) => (
            <section key={i} id={`s${i}`} className="scroll-mt-28 border-b border-[var(--n-line)] py-12 first:pt-0">
              <div className="flex items-baseline gap-5">
                <span className="f-lat text-5xl leading-none text-[var(--n-cyan)]">{String(i + 1).padStart(2, "0")}</span>
                <h2 className="f-ar text-3xl"><Hl text={s.title} q={t} /></h2>
              </div>
              <ol className="mt-8 space-y-5 pr-2 sm:pr-16">
                {s.items.map((it, j) => (
                  <li key={j} className="flex gap-5 text-[16px] leading-8 text-slate-300">
                    <span className="f-mono mt-1 shrink-0 text-xs text-slate-600">{i + 1}.{j + 1}</span><span><Hl text={it} q={t} /></span>
                  </li>
                ))}
              </ol>
            </section>
          ))}
        </div>
      </Wrap>
    </>
  );
}
